import { LOCALIZATION_CACHE_KEY_PREFIX as CACHE_KEY_PREFIX } from "../constants";
import localizationLogger from "../localizationLogger";
import { SupportedLanguage } from "../types";
const STORAGE_TRANSLATIONS_KEY = "data";
export default class LocalizationCache {
    storage;
    constructor(storage) {
        this.storage = storage;
    }
    async get(language) {
        try {
            const raw = await this.storage.getItem(CACHE_KEY_PREFIX + language);
            if (!raw)
                return null;
            const stored = JSON.parse(raw);
            return {
                version: stored["version"] ?? null,
                translations: stored[STORAGE_TRANSLATIONS_KEY] ?? {},
            };
        }
        catch (error) {
            localizationLogger.error(`Failed to parse cached localization for "${language}":`, error);
            return null;
        }
    }
    async set(language, version, translations) {
        await this.storage.setItem(CACHE_KEY_PREFIX + language, JSON.stringify({ version, [STORAGE_TRANSLATIONS_KEY]: translations }));
    }
    async getVersion(language) {
        return (await this.get(language))?.version ?? null;
    }
    async remove(language) {
        await this.storage.removeItem(CACHE_KEY_PREFIX + language);
    }
    async clear() {
        await Promise.all(Object.values(SupportedLanguage).map((lang) => this.remove(lang)));
    }
}
